<template>
  <vh-upload
    ref="com_upload"
    class="std-upload"
    :class="`std-upload--${size}`"
    list-type="picture-card"
    :headers="headersVo"
    :action="action"
    :data="extraData"
    name="resfile"
    :accept="accept"
    :on-success="handleUploadSuccess"
    :on-error="handleUpladError"
    :show-file-list="false"
    v-bind="$attrs"
  >
    <!-- v-if  已经有图片 -->
    <div
      class="upload-nonempty"
      :class="{ selected: selected, 'cover-badge': showCoverBadge }"
      v-if="domainUrl && domainUrl.indexOf('aliqr.e.vhall.com/qr.png') == -1"
    >
      <div class="upload-image-box">
        <img :src="domainUrl" class="upload-image" alt="" @click.stop.prevent="handleClickImage" />
      </div>
      <div class="upload-image-mask" :class="`upload-image-mask--${maskPosition}`">
        <div class="image-op" v-if="showCover" @click.stop.prevent="handleClickCover">
          <i class="vh-iconfont vh-a-icon_fengmian1" v-if="isFullMask"></i>
          <span>封面</span>
        </div>
        <div class="image-op" @click="handleResetImage($event)">
          <i class="vh-iconfont vh-line-refresh-left" v-if="isFullMask"></i>
          <span>更换</span>
        </div>
        <div class="image-op" @click.stop.prevent="handleDelete" v-if="showDelete">
          <i class="vh-iconfont vh-line-delete" v-if="isFullMask"></i>
          <span>删除</span>
        </div>
      </div>
    </div>

    <!--v-else 无图片 -->
    <div class="upload-empty" v-else>
      <i class="iconfont-v3 saasicon_shangchuan"></i>
      <div class="std-upload__tip">
        <slot name="tip">
          <!-- 小号上传框不显示tip -->
          <template v-if="size !== 'small'">
            <div>建议尺寸：{{ tipSize }}，小于{{ tipLimit }}</div>
            <div v-if="tipExt">支持{{ tipExt }}</div>
          </template>
        </slot>
      </div>
    </div>
  </vh-upload>
</template>
<script>
  import { sessionOrLocal } from '@vhcl/shared/utils/storage';
  import { setGrayId } from '@vhcl/shared/utils/common';
  import { v1 as uuidV1 } from 'uuid';
  export default {
    name: 'StdUpload',
    props: {
      // 上传失败是否提示
      isTipOnFail: {
        type: Boolean,
        default: true
      },
      imageUrl: {
        type: String
      },
      // 上传时附带的额外参数
      extraData: {
        type: Object,
        default: () => ({
          path: 'sys/img_url',
          type: 'image'
        })
      },
      // 上传地址
      action: {
        type: String,
        default: `${window.$hcl?.getCurrentEnvOpt().baseUrl}/v3/commons/upload/index`
      },
      // 上传支持类型
      accept: {
        type: String,
        default: 'image/jpg,image/jpeg,image/png,image/gif,image/bmp'
      },
      size: {
        type: String,
        default: 'default'
      },
      // 遮罩位置, 可选 full,bottom
      maskPosition: {
        type: String,
        default: 'full'
      },
      // 是否显示封面菜单
      showCover: {
        type: Boolean,
        default: false
      },
      // 是否显示封面标记
      showCoverBadge: {
        type: Boolean,
        default: false
      },
      // 是否显示删除菜单
      showDelete: {
        type: Boolean,
        default: true
      },
      // 是否选中
      selected: {
        type: Boolean,
        default: false
      },
      // 上传框提示的建议尺寸
      tipSize: {
        type: String,
        default: '1280*720px'
      },
      // 上传框提示的建议限制大小
      tipLimit: {
        type: String,
        default: '4M'
      },
      // 平台
      platform: {
        type: Number,
        default: 17
      },
      // 上传时是否显示显示loading框
      hasLoading: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        domainUrl: '',
        token: sessionOrLocal.get('token', 'localStorage') || '',
        loadingInstance: null //上传中的加载
      };
    },
    computed: {
      tipExt() {
        return (this.accept || '')
          .toLocaleLowerCase()
          .replaceAll('image/', '')
          .replaceAll(',', '、');
      },
      headersVo: function () {
        let vo = { token: this.token, platform: this.platform, 'request-id': uuidV1() };
        setGrayId(vo);
        return vo;
      },
      isFullMask() {
        return this.maskPosition === 'full';
      }
    },
    watch: {
      imageUrl: {
        handler(newVal) {
          this.domainUrl = newVal;
        },
        immediate: true
      }
    },
    methods: {
      // 上传失败
      handleUpladError(err, file, fileList) {
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
        if (this.isTipOnFail) {
          this.$vhMessage({
            message: '上传失败',
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        }
        this.$emit('uploadError', err, file, fileList);
      },
      // 图片上传完成的处理(成功失败都有可能)
      handleUploadSuccess(response, file, fileList) {
        // console.log('handleuploadSuccess---> ', response);
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
        if (response.code !== 200 || !response.data) {
          if (this.isTipOnFail) {
            this.$vhMessage({
              message: '上传失败',
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          }
          this.$emit('uploadError', response, file, fileList);
        } else {
          if (response.data.domain_url) {
            this.domainUrl = response.data.domain_url;
            this.$emit('update:imageUrl', response.data.domain_url);
          }
          this.$emit('uploadComplete', response, file, fileList);
        }
      },
      // 更换图片
      handleResetImage(event) {
        this.$emit('resetImage');
      },
      // 删除图片
      handleDelete() {
        this.domainUrl = '';
        this.$emit('update:imageUrl', '');
        this.$emit('delete');
      },
      // 点击 封面图标
      handleClickCover() {
        this.$emit('clickCover', '');
      },
      // 点击 图片
      handleClickImage() {
        if (!this.isFullMask) {
          this.$emit('clickImage');
        }
      },
      /**
       * 外层可直接调用的上传的方法
       */
      upload() {
        if (this.hasLoading) {
          this.loadingInstance = this.$vhLoading({
            lock: true,
            text: '图片上传中...'
          });
        }
        this.$refs.com_upload.submit();
      },
      /**
       * 外层可直接调用的选择文件的方法
       */
      resetChooseFile() {
        this.$refs.com_upload.clearFiles(); // 重新上传，清除之前的列表数据
        this.$refs.com_upload.$children[0].$refs.input.click();
      }
    }
  };
</script>
<style lang="less">
  .std-upload {
    width: 213px;
    height: 120px;

    &--small {
      width: 88px;
      height: 88px;
    }

    .vh-upload--picture-card {
      width: 100%;
      height: 100%;
      border: 1px dashed #d9d9d9 !important;
      box-sizing: border-box;
      line-height: normal;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .upload-empty {
        flex: 1;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        i {
          position: relative;
          font-size: 32px;
          height: 32px;
          width: 32px;
          line-height: 32px;
        }

        .std-upload__tip {
          font-size: 12px;
          color: #8c8c8c;
          text-align: center;
          margin-top: 6px;
          line-height: 20px;
        }
      }

      // 非空
      .upload-nonempty {
        flex: 1;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        position: relative;

        .upload-image-box {
          width: 100%;
          height: 100%;
          border-radius: 4px;

          .upload-image {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .upload-image-mask {
          position: absolute;
          left: 0;
          width: 100%;
          background: rgba(0, 0, 0, 0.7);
          display: none;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          .image-op {
            color: #fff;
            display: flex;
            flex-direction: column;
            font-size: 14px;
            &:not(:first-child) {
              margin-left: 10px;
            }
            i {
              color: #fff;
              font-size: 18px;
              vertical-align: middle;
              // line-height: 1;
            }
          }
          &--full {
            top: 0;
            height: 100%;
          }
          &--bottom {
            bottom: 0;
            border-radius: 2px 2px 0 0;
            padding: 5px 0;
          }
        }

        &:hover {
          .upload-image-mask {
            display: flex;
          }
        }
      }

      // 图片有封面标记
      .upload-nonempty.cover-badge {
        &::before {
          position: absolute;
          top: -1px;
          left: -1px;
          content: '封面';
          color: #fff;
          background: #fb3a32;
          border-radius: 4px 0 12px 0;
          color: #fff;
          font-size: 12px;
          display: inline-block;
          text-align: center;
          width: 40px;
          line-height: 22px;
          height: 22px;
          z-index: 11;
        }
      }

      // 图片选中
      .upload-nonempty.selected {
        border: 1px solid red;

        &::after {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgBzdi9jgFRGMbx552xUdEodQqJzlbaLXSuAdegVeza7J1wA/SIROcGiGobHYmg2+zOzjMivgZnxpmPfzI5zin4OTNGMvKTz7cAfCDaugnDaMhs9i2cxQS1tlGvcpjFAmVZIzmdxwC1lsuVqFHithglynBbfJnPW/bwiQCTQgHKIBYUSlIpJLpdmPZh1OtQBgWBIsbsdADuzmYDq9+HJ5BO1CXmt1aDtVjAM0gVlRgOncPt2pBsFmavt8fYCAcznbq+jxJIBeV8W35wuw0pl88x3Bl7dDDV6k0MM+Ghr9Vq9J7J8FbxdgUaDCDFIiSXg1GpANstsFxeY1xO02kCH927TxnN5vHXY18rSKeVMczTDh26u1PjsTNKqQQkk54wvkEPUZPJ/sVuh79GQxnDfJ2y03T/zTwNYjpRWkBMF0obiOlAaQWxZ1HaQewZVCAg5hcVGIj5QQUKYl5RgYOYF1QoIKaKCg3EVFChgtgjVOggdg8VCYjdQkUGYm6oSEHsEhU5iMXk+dR5RNmHhThF1D98jrnANprgQwAAAABJRU5ErkJggg==);
          background-position: 50%;
          -webkit-background-size: contain;
          background-size: contain;
          content: '';
          height: 20px;
          position: absolute;
          right: -1px;
          top: -1px;
          width: 20px;
          z-index: 10;
        }
      }
    }
  }
</style>
